import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

export interface TariffListUpdatedAtCellProps
  extends CellContext<TariffModel, TariffModel['updatedAt']> {}

export const TariffListUpdatedAtCell = (
  props: TariffListUpdatedAtCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{formatDate(getValue(), i18n)}</Text>;
};
